<template>
  <div>
    <v-card class="transparent elevation-0">
      <v-container container--fluid grid-list-md>
        <v-row>
          <v-col cols="12">
            <h1>Receive orders</h1>
          </v-col>
        </v-row>
        <v-row justify="space-between">
          <v-col cols="12" sm="12" md="3">
            <v-text-field label="Search..." v-model="search" prepend-icon="search"></v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="2">
            <v-menu
              v-model="date_menu"
              close-on-content-click
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="date"
                  readonly
                  prepend-icon="fas fa-calendar"
                  label="Date"
                  @click.native="date_menu = true"
                ></v-text-field>
              </template>
              <v-date-picker v-model="date" @input="date_menu=false"></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" sm="12" md="2">
            <v-select
              label="Choose a depot"
              :items="depots"
              item-text="name"
              item-value="id"
              v-model="depot"
              prepend-icon="fas fa-warehouse"
            ></v-select>
          </v-col>

          <v-col cols="5" md="2">
            <v-switch
              style="justify-content: center"
              color="blue"
              v-model="showClosed"
              label="Show Closed"
            ></v-switch>
          </v-col>

          <v-col cols="2" md="1" class="text-center">
            <v-tooltip top color="secondary">
              <template v-slot:activator="{ on }">
                <v-btn text large @click="updateDataTable" v-on="on">
                  <v-icon color="cyan darken-2">refresh</v-icon>
                </v-btn>
              </template>
              <span>Refresh</span>
            </v-tooltip>
          </v-col>

          <v-col cols="4" md="1" class="text-center">
            <v-tooltip top color="secondary">
              <template v-slot:activator="{ on }">
                <v-btn v-if="isInventoryManager" class="mx-2" fab dark color="blue lighten-1" @click="newReceiveOrder"
                       v-on="on">
                  <v-icon dark>add</v-icon>
                </v-btn>
              </template>
              <span>Create a new receive order</span>
            </v-tooltip>
          </v-col>

        </v-row>
      </v-container>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        :search="search"
        :loading="loading"
        :items="renderedOrders"
      >
        <template v-slot:item="props">
          <tr class="cursor" v-bind:class="{odd: props.index % 2, even: !props.index % 2}">
            <td style="text-align: center" v-if="header.text !== 'Actions'" v-for="(header, index) in headers"
                :key="index">
              {{props.item[header.value]}}
            </td>
            <td class="text-center">
              <v-tooltip top color="secondary" v-if="isInventoryManager && !props.item.is_consolidation">
                <template v-slot:activator="{ on }">
                  <v-icon @click="editRow(props.item)" color="blue" v-on="on">
                    edit
                  </v-icon>
                </template>
                <span>Edit</span>
              </v-tooltip>
              <v-tooltip top color="secondary" v-if="props.item.is_consolidation">
                <template v-slot:activator="{ on }">
                  <v-icon @click="getConsolidationReport(props.item)" color="blue" v-on="on">
                    description
                  </v-icon>
                </template>
                <span>Consolidation Report</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>

    <CreateReceiveOrder
      :receivingOrder="receivingOrder"
      :createReceiveOrderDialog="createReceiveOrderDialog"
      v-on:updateDataTable="updateDataTable()"
      @close="closeCreateReceiveOrderDialog"
      @save="CreateReceiveOrder"
      @closeItem="closeItemDialog"
      @openItemsDialog="openItemDialog"
      :itemsDialog="itemsDialog"
      :editedIndexReceiveOrder="editedIndexReceiveOrder"
      :isSaved="isSaved"
    ></CreateReceiveOrder>

  </div>

</template>

<script>
    import axios from 'axios';
    import CreateReceiveOrder from "./CreateReceiveOrder";

    export default {
        name: "ReceivingOrders",
        components: {
            CreateReceiveOrder
        },
        data() {
            return {
                editDialog: false,
                showClosed: false,
                search: '',
                loading: false,
                pagination: {rowsPerPage: 10},
                reload: false,
                isVisible: false,
                date: (new Date()).toISOString().split('T')[0],
                date_menu: false,
                headers: [
                    {text: 'Id', value: 'id', align: 'center', sortable: true},
                    {text: 'ETA', value: 'eta', align: 'center', sortable: true},
                    {text: 'Sender name', value: 'sender_name', align: 'center', sortable: true},
                    {text: 'Pallets Requested', value: 'pallets_requested', align: 'center', sortable: true},
                    {text: 'Pallets Received', value: 'pallets_received', align: 'center', sortable: true},
                    {text: 'Items Requested', value: 'requested_items', align: 'center', sortable: true},
                    {text: 'Items Received', value: 'received_items', align: 'center', sortable: true},
                    {text: 'Exchange', value: 'exchange_pallets', align: 'center', sortable: true},
                    {text: 'Carrier', value: 'carrier', align: 'center', sortable: true},
                    {text: 'Actions', value: 'actions', align: 'center', sortable: false}
                ],
                editedIndexReceiveOrder: -1,
                createReceiveOrderDialog: false,
                isEditing: false,
                itemsDialog: null,
                depots: null,
                isSaved: false,
                depot: 1,
                receivingOrder: {
                    id: 0,
                    client_id: null,
                    client_name: null,
                    depot_id: null,
                    depot_name: null,
                    date: null,
                    eta: null,
                    number: null,
                    sender_name: null,
                    sender_address: null,
                    sender_suburb: null,
                    sender_state: null,
                    sender_poscode: null,
                    sender_reference: null,
                    notes: null,
                    num_pallets: null,
                    exchange_pallets: true,
                    carrier: null,
                    carrier_reference: null,
                    sorter_production_id: null,
                    sorter_production_name: null,
                    requested_items: null,
                    received_items: null,
                    pallets_requested: null,
                    pallets_received: null,
                    approved: null,
                    approved_by: null,
                    closed: null,
                    created: null,
                    edited: null,
                },
                default: {
                    id: 0,
                    client_id: null,
                    client_name: null,
                    depot_id: 1,
                    depot_name: null,
                    date: null,
                    eta: null,
                    number: null,
                    sender_name: null,
                    sender_address: null,
                    sender_suburb: null,
                    sender_state: null,
                    sender_postcode: null,
                    sender_reference: null,
                    notes: null,
                    num_pallets: null,
                    exchange_pallets: true,
                    carrier: null,
                    carrier_reference: null,
                    sorter_production_id: null,
                    sorter_production_name: null,
                    requested_items: null,
                    received_items: null,
                    pallets_requested: null,
                    pallets_received: null,
                    approved: null,
                    approved_by: null,
                    closed: null,
                    created: null,
                    edited: null,
                },
                timer: '',
            }
        },
        mounted: function () {
            this.timer = setInterval(() => {
                this.reload = !this.reload;
            }, 300000);
            this.getDepots();
        },
        beforeDestroy() {
            clearInterval(this.timer)
        },
        computed: {
            renderedOrders() {
                if (this.orders === null || this.orders === undefined) return [];
                if (!this.showClosed) {
                    return this.orders.filter((order) => {
                        return !order.closed;
                    })
                } else {
                    return this.orders;
                }
            },
        },
        asyncComputed: {
            async orders() {
                if (this.reload || !this.reload) {
                    this.loading = true;
                    return await axios.get(process.env.API_URL + '/receivingorders?depot=' + this.depot + '&date=' + this.date)
                        .then((response) => {
                            if (response.status === 200) {
                                this.loading = false;
                                this.reload = false;
                                return response.data;
                            } else {
                                this.loading = false;
                                return [];
                            }
                        })
                        .catch((error) => {
                            this.loading = false;
                            this.reload = false;
                            return [];
                        });
                }
            }
        },
        methods: {
            isInventoryManager() {
                return this.$store.getters['auth/inventory_manage'];
            },
            newReceiveOrder() {
                this.isSaved = false;
                this.editedIndexReceiveOrder = -1;
                this.receivingOrder = Object.assign({}, this.default);
                this.createReceiveOrderDialog = true;
            },
            CreateReceiveOrder() {
                let body = this.receivingOrder;

                if (this.editedIndexReceiveOrder > -1) {
                    // EDIT
                    axios.put(process.env.API_URL + '/receivingorders/' + this.receivingOrder.id, body)
                        .then((response) => {
                            this.$store.commit('displaySnackbar', 'Changes saved');
                            this.updateDataTable();
                        })
                        .catch((error) => {
                            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                        });
                    this.isSaved = true;
                } else {
                    // CREATE
                    console.log(body)
                    axios.post(process.env.API_URL + '/receivingorders', body)
                        .then((response) => {
                            this.$store.commit('displaySnackbar', 'Create successful');
                            this.receivingOrder.id = response.data.id;
                            this.itemsDialog = true;
                            this.isSaved = true;
                            this.updateDataTable();
                        })
                        .catch((error) => {
                            this.itemsDialog = false;
                            this.isSaved = false;
                            this.$store.commit('displaySnackbar', 'ERROR: Create failed');
                        });
                    console.log(this.receivingOrder);
                    // this.itemsDialog = true;
                    // this.isSaved = true;
                }
            },
            // @vuese
            // Gets all the depots
            getDepots() {
                axios.get(process.env.API_URL + '/depots?wms=true')
                    .then((response) => {
                        this.depots = response.data;
                    })
                    .catch((response) => {
                        this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                    })
            },
            editRow(item) {
                this.receivingOrder = Object.assign({}, item);
                this.editedIndexReceiveOrder = this.orders.indexOf(item);
                this.createReceiveOrderDialog = true;
            },
            getConsolidationReport(item) {
              window.open(process.env.API_URL + '/receivingorders/' + item.id + '/consolidationreport?key=' + encodeURI(this.$store.state.auth.key), '_blank')
            },
            closeCreateReceiveOrderDialog() {
                this.receivingOrder = Object.assign({}, this.default);
                this.createReceiveOrderDialog = false;
                this.reload = !this.reload;
            },
            closeItemDialog() {
                this.itemsDialog = false;
            },
            openItemDialog() {
                this.itemsDialog = true;
            },
            updateDataTable() {
                this.reload = !this.reload;
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/util/Inventory/ReceivingOrders.vue